import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function forbidSQLKeywordsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const blacklist = [
      /\bSELECT\b/i,
      /\bFROM\b/i,
      /\bUPDATE\b/i,
      /\bINSERT\b/i,
      /\bDELETE\b/i,
      /\bCREATE\b/i,
      /\bDROP\b/i,
      /\bALTER\b/i,
      /\bJOIN\b/i,
      /\bUNION\b/i,
      /\bWITH\b/i,
    ];
    let forbidden;
    for (const item in blacklist) {
      if (blacklist[item].test(control.value)) {
        forbidden = blacklist[item].test(control.value);
      }
    }
    return forbidden ? { forbiddenName: { value: control.value } } : null;
  };
}

const EMAIL_PATTERN = /^[^\s@,;]+@[^\s@,;.]+(\.[^\s@,;.]+)+$/;

/**
 * Validates a comma-separated list of email addresses. SendGrid rejects an
 * entire batch on a single malformed address, so a typo here would otherwise
 * silently stop the submission email reaching anyone.
 */
export function emailListValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value !== 'string') return null;

    const invalid = value
      .split(',')
      .map((entry) => entry.trim())
      .filter((entry) => entry.length > 0)
      .filter((entry) => !EMAIL_PATTERN.test(entry));

    return invalid.length ? { invalidEmails: { value: invalid } } : null;
  };
}
